import { Filters, Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { findAllQuestionPassages, findAllQuestionPassagesVariables } from '__generatedTypes__/findAllQuestionPassages'
import { GET_QUESTION_PASSAGES_LIST } from 'queries/questionPassage'
import { SearchTypeEnum } from '__generatedTypes__/globalTypes'

export function castParams({ page, take, search, order }: Params<Filters>): findAllQuestionPassagesVariables {
  return {
    params: {
      skip: (page - 1) * take,
      take,
      search: search ? { query: search, type: SearchTypeEnum.ILike } : undefined,
      order: order?.field ? { [order.field]: order.direction } : undefined,
    },
  }
}

export function useQuestionPassages() {
  return useQueryWithParams<
    findAllQuestionPassages,
    findAllQuestionPassagesVariables,
    'findAllQuestionPassage',
    'items',
    'count'
  >(GET_QUESTION_PASSAGES_LIST, 'findAllQuestionPassage', 'items', 'count', castParams, undefined, {
    fetchPolicy: 'network-only',
  })
}
